import { KnBrCustomerService } from './../../store/kn-br-customer/kn-br-customer.service';
import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AuthService, CmsService, RoutingService, UrlPipe, TranslatePipe } from '@spartacus/core';
import { Observable, Subject, Subscription, of } from 'rxjs';
import { map, takeUntil, filter } from 'rxjs/operators';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';

import { KnBrCustomerContextService } from '../../store/kn-br-customer-context/kn-br-customer-context.service';
import { CustomerData } from './../../models/customer.model';
import { KnBrSidebarService } from './../../services/kn-br-sidebar.service';
import { UserAccountFacade } from '@spartacus/user/account/root';
import {
  OutletRefDirective,
  GlobalMessageComponent,
  PageLayoutComponent,
  PageSlotComponent,
  MediaComponent,
} from '@spartacus/storefront';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import { Router, RouterLink } from '@angular/router';
import { AsyncPipe, NgClass} from '@angular/common';
import { RemoveLeadingZerosPipe } from '../../shared/pipe/kn-br-custom-pipes/remove-leading-zeros.pipe';
import { Auth0Service } from 'src/app/services/knbr-new-auth0.service';
import { MiniCartComponentService } from "@spartacus/cart/base/components/mini-cart";
import { KnBrCartContextService } from 'src/app/store/kn-br-cart-context/kn-br-cart-context.service';
import { Cart, MultiCartFacade, OrderEntry } from '@spartacus/cart/base/root';
import { ActiveCartService } from '@spartacus/cart/base/core';
import {ChangeDetectorRef} from '@angular/core';

@Component({
  selector: 'kn-br-outlet',
  templateUrl: './kn-br-outlet.component.html',
  styleUrls: ['./kn-br-outlet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    OutletRefDirective,
    GlobalMessageComponent,
    PageLayoutComponent,
    PageSlotComponent,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownItem,
    RouterLink,
    AsyncPipe,
    UrlPipe,
    TranslatePipe,
    RemoveLeadingZerosPipe,
    NgClass,
    MediaComponent,
  ],
})
export class KnBrOutletComponent implements OnInit, OnDestroy {
  isHeaderHidden = false;
  customerContext$: Observable<CustomerData> = this.customerContextService.get$;
  isLoggedIn$: Observable<boolean> = this.authService.isUserLoggedIn();
  redirectionDetail$: Observable<any> = this.knBrCommonService.redirectionDetail$;
  user$ = this.userService.get();
  selectedCustomer;
  subscription = new Subscription();
  pageTemplateName = '';
  private destory$ = new Subject<void>();
  isOpenMiniCartDropdown: boolean = false;
  quantity$: Observable<any> = this.miniCartComponentService.getQuantity();
  cartContext$: Observable<string> = this.knBrCartContextService.get$;
  hideCart = false;
  miniCart$: Observable<Cart>;
  cartId: string;
  cartEntries$: Observable<OrderEntry[]>;
  cartEntriesArray: OrderEntry[] = [];

  readonly isLoginPage$ = this.cmsService
    .getCurrentPage()
    .pipe(
      map(
        (page) =>
          page &&
          (page.template === 'KnBrLoginPageTemplate' ||
            page.template === 'knBrQuoteSellerApproverTemplate' ||
            page.template === 'KnBrRegistrationPageTemplate')
      )
    );
  readonly isUndefinedPage$ = this.cmsService
    .getCurrentPage()
    .pipe(
      map(
        (page) =>
          !page || page.template === 'knBrQuoteSellerApproverTemplate' || page.template === 'ContentPage1Template'
      )
    );
  readonly hideBreadCrumb$ = this.cmsService
    .getCurrentPage()
    .pipe(
      map(
        (page) =>
          page &&
          (page.template === 'KnBrLandingPage2Template' ||
            page.template === 'KnBrSearchResultsListPageTemplate' ||
            page.template === 'KnBrProductListPageTemplate' ||
            page.template === 'KnBrProductGridPageTemplate' ||
            page.template === 'KnBrSearchResultsGridPageTemplate' ||
            page.template === 'KnBrProductDetailsPageTemplate')
      )
    );
  readonly isStaticPage$ = this.cmsService
    .getCurrentPage()
    .pipe(map((page) => page && page.template === 'ContentPage1Template'));
  readonly isNacPage$ = this.cmsService
    .getCurrentPage()
    .pipe(map((page) => !page || page.template === 'NACPageTemplate'));
  constructor(
    private cmsService: CmsService,
    private customerContextService: KnBrCustomerContextService,
    private userService: UserAccountFacade,
    private sidebarService: KnBrSidebarService,
    private knBrCommonService: KnBrCommonService,
    private authService: AuthService,
    private customerSearchService: KnBrCustomerService,
    protected routing: RoutingService,
    protected newAuthService: Auth0Service,
    private knBrCartContextService: KnBrCartContextService,
    protected miniCartComponentService: MiniCartComponentService,
    protected activeCartService: ActiveCartService,
    private multiCartFacade: MultiCartFacade,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.subscription.add(
      this.cmsService.getCurrentPage().subscribe((page) => {
        if (page) {
          this.pageTemplateName = page.template;
          if (page?.pageId === "purchasingAgentPage") {
            this.hideCart = true;
          }
          else{
            this.hideCart = false;
          }
        }
      })
    );

    this.subscription.add(
      this.knBrCartContextService.get$.subscribe((response) => {
        this.cartId = response ? response : null;
      })
    );

    // subscribe to mini cart open state from common service
    this.subscription.add(
      this.knBrCommonService.getMiniCartOpen().subscribe((open) => {
        this.isOpenMiniCartDropdown = !!open;
        this.cdr.detectChanges();
      })
    );
  }

  showCartPage() {
    const currentUrl = this.router.url;
    const excludeMiniCart = ["salesCart"];
    if (excludeMiniCart.some((route) => currentUrl.includes(route))) {
      return false;
    } else {
      this.routing.goByUrl('salesCart');
    }
  }

  showMiniCart() {
    const currentUrl = this.router.url;
    const excludeMiniCart = ["salesCart", "salesCheckout"];
    if (excludeMiniCart.some((route) => currentUrl.includes(route))) {
      return false;
    } else {
      this.knBrCommonService.setMiniCartOpen(true);
    }
  }

  hideMiniCart() {
    this.knBrCommonService.setMiniCartOpen(false);
  }

  goToLocation(url) {
    this.knBrCommonService.setMiniCartOpen(false);
    this.knBrCommonService.setSpinner(true);
    this.router.navigateByUrl(url);
  }

  removeCustomerContext() {
    if (
      this.pageTemplateName === 'CarlisleShippingListingPageTemplate' ||
      this.pageTemplateName === 'KnBrQuotePageTemplate' ||
      this.pageTemplateName === 'KnBrOrderHistoryPageTemplate' ||
      this.pageTemplateName === 'KnBrInvoiceListPageTemplate' ||
      this.pageTemplateName === 'KnBrReturnHistoryPageTemplate' ||
      this.pageTemplateName === 'KnBrQuotePageTemplate'
    ) {
      window.location.reload();
    } else {
      this.routing.goByUrl('');
    }

    this.customerContextService.delete();
  }

  ngOnInit() {
    this.subscription.add(
      this.isLoggedIn$.subscribe((res) => {
        if (res) {
            this.knBrCommonService.getRedirectionDetail().pipe(takeUntil(this.destory$)).subscribe({
              next: (redirect) => {
                this.knBrCommonService.redirectionDetail$.next(redirect);
              },
              error: (error) => {
                console.error('Error occurred while fetching redirection detail:', error);
                this.logout();
              }
            });
        }
      })
    );
    this.subscription.add(
      this.user$.subscribe((user: any) => {
        if (user && user.customerId) {
          this.customerContextService.set({ customerName: user.customerName, customerNumber: user.customerId });
        }
      })
    );
    this.subscription.add(
      this.customerSearchService.list$.subscribe((customerList) => {
        if (customerList && customerList.length > 0 && this.selectedCustomer) {
          const customertosetcontext = customerList.find(
            (customer) => customer.customerNumber === this.selectedCustomer.customerNumber
          );
          if (customertosetcontext) {
            this.customerContextService.set(customertosetcontext);
          }
        }
      })
    );
    this.subscription.add(
      this.customerContextService.get$.subscribe((customerdata) => {
        this.selectedCustomer = customerdata;
        if (customerdata && !customerdata.hasOwnProperty('telephone')) {
          this.customerSearchService.search(null);
        }
      })
    );

    // Mini cart initialization
    this.subscription.add(
      this.cartContext$.subscribe((code) => {
        if (!code) {
          this.quantity$ = of(0);
          this.miniCart$ = of({} as Cart);
          this.cartEntries$ = of([]);
          this.cdr.detectChanges();
          return;
        }
        this.quantity$ = this.miniCartComponentService.getQuantity()
        this.multiCartFacade.reloadCart(code);
        this.cdr.detectChanges();
        this.miniCart$ = this.multiCartFacade.getCart(code).pipe(
          filter((cart) => !!cart),
          map((cart) => cart)
        );
      })
    );
    this.cartEntries$ = this.activeCartService
      .getEntries()
      .pipe(filter((entries) => entries.length > 0));
      this.cartEntries$.subscribe(entries => {
       this.cartEntriesArray = entries;
        this.cdr.detectChanges();
      });
  }

  logout() {
    this.authService.coreLogout();
    this.newAuthService.logOutTheUser();
    // this.routing.goByUrl('/logout');
  }

  changeMenuState() {
    this.sidebarService.toggleMenuState();
  }

  ngOnDestroy() {
    this.selectedCustomer = undefined;
    this.destory$.next();
    this.destory$.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
